// extracted by mini-css-extract-plugin
export default {"container":"EventCard_container__vtYTD","text":"EventCard_text__099gc","highlights":"EventCard_highlights__cdORt","highlight":"EventCard_highlight__HqDGh"};